import { Sale, SaleForm } from "./sales.model";
import { PaymentMode } from "./payment-modes.model";

export class PurchaseOrder extends Sale {

    type: 'Quote' | 'Command';
    designation: string;
    paymentMode: PaymentMode
    transport: boolean;
    transportAmount: number;
    amount: number;

    constructor() {
        super();
        this.paymentMode = new PaymentMode();
    }

}

export class PurchaseOrderForm extends SaleForm {

    type: 'Quote' | 'Command';
    designation: string;
    paymentMode: number;
    transport: boolean;
    transportAmount: number;
    amount: number;

    constructor() {
        super();
    }
}


